// Generated by ts-to-zod
import { z } from 'zod';

export const startAnnotationPayloadSchema = z.object({
  statuses: z.array(z.string()).optional(),
});
